import React, { Component } from "react";
import { Redirect, Route, BrowserRouter as Router } from "react-router-dom";
import { Layout } from "antd";
import AccountDump from "./account_dump/DumpAccount";
import VDNSManager from "./vdns_manager/VDNSManager";
import NavMenu from "./common/NavMenu";
import { checkAuth } from "./common/Auth";

const { Content } = Layout;

class App extends Component {
  state = { auth: undefined };

  componentDidMount () {
    checkAuth()
      .then((auth) => {
        this.setState({ auth });
      })
      .catch(() => this.setState({ auth: undefined }));
  }

  render () {
    const { auth } = this.state;
    return (
      <Router>
        <Layout style={{ "minHeight": "100vh" }}>
          <NavMenu auth={auth} />
          <Content>
            <Route
              exact
              path="/callback"
              render={
                () => auth ? <Redirect to="/vvp_account_dump" /> : null
              }
            />
            <Route
              path="/vvp_account_dump"
              render={ () => <AccountDump service={'vvp'}/> }
            />
            <Route
              path="/vdns_manager"
              render={ () => <VDNSManager auth={ auth }/> }
            />
          </Content>
        </Layout>
      </Router>
    );
  }
}

export default App;
